'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _compose = require('recompose/compose');

var _compose2 = _interopRequireDefault(_compose);

var _mapProps = require('recompose/mapProps');

var _mapProps2 = _interopRequireDefault(_mapProps);

var _getContext = require('recompose/getContext');

var _getContext2 = _interopRequireDefault(_getContext);

var _dataSelectors = require('../selectors/dataSelectors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var enhance = function enhance(OriginalComponent) {
  return (0, _compose2.default)((0, _getContext2.default)({
    events: _react.PropTypes.object
  }), (0, _reactRedux.connect)(function (state, props) {
    return {
      maxPages: (0, _dataSelectors.maxPageSelector)(state, props),
      currentPage: (0, _dataSelectors.currentPageSelector)(state, props),
      className: (0, _dataSelectors.classNamesForComponentSelector)(state, 'PageDropdown'),
      style: (0, _dataSelectors.stylesForComponentSelector)(state, 'PageDropdown')
    };
  }), (0, _mapProps2.default)(function (_ref) {
    var setPage = _ref.events.onGetPage,
        props = _objectWithoutProperties(_ref, ['events']);

    return _extends({}, props, {
      setPage: setPage
    });
  }))(function (props) {
    return _react2.default.createElement(OriginalComponent, props);
  });
};

exports.default = enhance;


//////////////////
// WEBPACK FOOTER
// ./~/griddle-react/dist/module/components/PageDropdownContainer.js
// module id = 1097
// module chunks = 0